import React, { Dispatch, SetStateAction } from 'react';
import { GqlImageBanner } from 'types/graphql';
import { ScheduleForm } from 'src/components/schedule-form';

type ScheduleStepProps = {
  banner: GqlImageBanner | undefined;
  currentStepIndex: number;
  setStepNumber: (newStep: number) => void;
  setBannerData: (data: Partial<GqlImageBanner>) => void;
  setIsDirty: Dispatch<SetStateAction<boolean>>;
};

/**
 * Schedule step for image banner creation/editing
 * Wraps the ScheduleForm component to work with image banners
 */
export function ScheduleStep({
  banner,
  currentStepIndex,
  setStepNumber,
  setBannerData,
  setIsDirty,
}: ScheduleStepProps): JSX.Element {
  // Adapt the collection-based ScheduleForm to work with image banners
  const handleSetScheduleData = ({ schedule }: { schedule: any }): void => {
    setBannerData({ schedule });
  };

  // Convert banner to collection-like structure for ScheduleForm
  const bannerAsCollection = banner
    ? ({
        schedule: banner.schedule,
      } as any)
    : undefined;

  return (
    <ScheduleForm
      collection={bannerAsCollection}
      currentStepIndex={currentStepIndex}
      setStepNumber={setStepNumber}
      setCollectionData={handleSetScheduleData}
      setIsDirty={setIsDirty}
    />
  );
}
